import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { driver } from "driver.js";
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { GuiService } from 'src/app/services/gui.service';

@Component({
  selector: 'vex-change-week',
  templateUrl: './change-week.component.html',
  styleUrls: ['./change-week.component.scss']
})
export class ChangeWeekComponent implements OnInit {
  program: any;
  environment = environment.baseURL;
  openedWeek: any;
  selectedWeek;

  constructor(public guiService: GuiService, public translate: TranslateService, private router: Router) {

  }

  ngOnInit(){
    setTimeout(() => {
      localStorage.getItem('tourChangeWeekShowed') ? null : this.startTour();
    }, 800);

    !this.guiService.userLogged ? this.guiService.goTo('main/home') : null;
    console.debug(this.guiService?.currentProgram)
    this.program = this.guiService?.currentProgram;
    console.debug(this.guiService?.userLogged?.workoutInfo.programs[this.guiService?.currentProgram?._id].week)
    this.selectedWeek = this.guiService?.userLogged?.workoutInfo.programs[this.guiService?.currentProgram?._id].week;
    this.openedWeek = this.guiService?.userLogged?.workoutInfo.programs[this.guiService?.currentProgram?._id].week;
  }

  changeWeek(){
    this.guiService.userLogged.workoutInfo.programs[this.guiService?.currentProgram?._id].week= this.selectedWeek;
    this.guiService.goTo('main/home');
  }

  startTour(): void {
    localStorage.setItem('tourChangeWeekShowed', 'true')

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.week-chip', popover: { title: this.translate.instant('TUTORIALS.change-week.activeWeekTitle'), description: this.translate.instant('TUTORIALS.change-week.activeWeekDescription') } },
        { element: '.custom-accordion', popover: { title: this.translate.instant('TUTORIALS.change-week.chooseWeekTitle'), description: this.translate.instant('TUTORIALS.change-week.chooseWeekDescription') } },
        { element: '.change-week-btn-modal-tutorial', popover: { title: this.translate.instant('TUTORIALS.change-week.confirmWeekTitle'), description: this.translate.instant('TUTORIALS.change-week.confirmWeekDescription') } }
      ]
    });

    driverObj.drive();
  }

  public getWorkoutValue(workout: any): any {
    return workout?.value;
  }

}
